import React, { useEffect, useState } from 'react';
import { XIcon, ShoppingBagIcon } from 'lucide-react';
const purchases = [{
  name: 'Giulia F.',
  city: 'Milano'
}, {
  name: 'Marco B.',
  city: 'Roma'
}, {
  name: 'Silvia R.',
  city: 'Torino'
}, {
  name: 'Davide M.',
  city: 'Napoli'
}, {
  name: 'Laura C.',
  city: 'Bologna'
}, {
  name: 'Alessandro P.',
  city: 'Firenze'
}, {
  name: 'Francesca T.',
  city: 'Verona'
}, {
  name: 'Roberto G.',
  city: 'Genova'
}, {
  name: 'Chiara V.',
  city: 'Palermo'
}, {
  name: 'Stefano L.',
  city: 'Bari'
}];
export function UrgencyBanner() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(purchases[0]);
  useEffect(() => {
    const showPopup = () => {
      setCurrent(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      setTimeout(() => setVisible(false), 6000);
    };
    const interval = setInterval(showPopup, 15000);
    const initial = setTimeout(showPopup, 4000);
    return () => {
      clearInterval(interval);
      clearTimeout(initial);
    };
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-3 left-3 right-3 sm:left-auto sm:right-4 z-50 animate-slide-in flex justify-center sm:justify-end pointer-events-none" role="status" aria-live="polite" data-id="element-150" data-mp="22nhqkuno3ra4">
      <div className="bg-white border-2 border-cta shadow-[0_0_20px_rgba(230,126,34,0.5)] rounded-lg p-2 pr-7 max-w-[275px] w-full relative pointer-events-auto" data-id="element-151" data-mp="1sqleyg2h2p1c">
        <div className="absolute top-0 left-0 w-full h-1 bg-cta rounded-t" data-id="element-152" data-mp="2qb7ziua38gu3" />
        <button onClick={() => setVisible(false)} aria-label="Chiudi notifica" className="absolute top-1 right-1 text-warmgray/50 hover:text-warmgray transition-colors" data-id="element-153" data-mp="2lfaismuwx8gs">
          <XIcon className="w-3.5 h-3.5" data-id="element-154" data-mp="2cfvt3pmkl1xc" />
        </button>
        <div className="flex items-center gap-2.5 mt-1" data-id="element-155" data-mp="151al7ijjhuwp">
          <div className="w-8 h-8 rounded-full bg-sage flex items-center justify-center shrink-0" data-id="element-156" data-mp="10ynpv7nntrur">
            <ShoppingBagIcon className="w-4 h-4 text-white" data-id="element-157" data-mp="12ftened7v2qm" />
          </div>
          <div className="leading-tight" data-id="element-158" data-mp="12dqfa3q6bx98">
            <p className="font-heading font-bold text-petrol text-[13px]" data-id="element-159" data-mp="17ffsnq0vcn0h">
              {current.name} — {current.city}, Italia
            </p>
            <p className="text-[11px] text-sage font-semibold" data-id="element-160" data-mp="shdopepxdzip">
              ha appena acquistato SENIOR FITNESS COACH PRO™
            </p>
          </div>
        </div>
      </div>
    </div>;
}